import { render, staticRenderFns } from "./PckgSales.vue?vue&type=template&id=f6a97b82&"
import script from "./PckgSales.vue?vue&type=script&lang=js&"
export * from "./PckgSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6a97b82')) {
      api.createRecord('f6a97b82', component.options)
    } else {
      api.reload('f6a97b82', component.options)
    }
    module.hot.accept("./PckgSales.vue?vue&type=template&id=f6a97b82&", function () {
      api.rerender('f6a97b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/PckgSales.vue"
export default component.exports